import { render, staticRenderFns } from "./DHLReturnShow.vue?vue&type=template&id=9809a118&scoped=true"
import script from "./DHLReturnShow.vue?vue&type=script&lang=js"
export * from "./DHLReturnShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9809a118",
  null
  
)

export default component.exports